import { render, staticRenderFns } from "./VBurgerMenu.vue?vue&type=template&id=36e27d8a&scoped=true&"
import script from "./VBurgerMenu.vue?vue&type=script&lang=js&"
export * from "./VBurgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./VBurgerMenu.vue?vue&type=style&index=0&id=36e27d8a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e27d8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/myretro/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e27d8a')) {
      api.createRecord('36e27d8a', component.options)
    } else {
      api.reload('36e27d8a', component.options)
    }
    module.hot.accept("./VBurgerMenu.vue?vue&type=template&id=36e27d8a&scoped=true&", function () {
      api.rerender('36e27d8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VBurgerMenu.vue"
export default component.exports